import React from 'react';
import useStyle from './connectedStateModal.style';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { IconButton } from '../../../atoms/Buttons/IconButton';

export interface ConnectedStateModalViewProps {
  title: string;
  children?: React.ReactNode;
  actionButton?: React.ReactNode;
  onClose?: () => void;
}

export const ConnectedStateModalView = ({
  title,
  onClose,
  children,
  actionButton
}: ConnectedStateModalViewProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <FeatureContainer
          buttonPosition="topRight"
          padding="small"
          iconButton={
            <IconButton onClick={onClose} icon="Close" variant="backless" />
          }
        >
          <span className={classes.modalHead}>{title}</span>
          {children}
          {actionButton && <div onClick={onClose}>{actionButton}</div>}
        </FeatureContainer>
      </div>
    </div>
  );
};
